module.exports = __webpack_public_path__ + "static/img/A97.7a503a43.jpg";